import React from "react";
import "./radio-button2.css";

const RadionButton2 = ({ mode, id, name, value, title, checked, onChange }) => {
  return (
    <div className="radio-wrapper-22">
      <label className="radio-wrapper" htmlFor={id}>
        <input
          className="radio-input"
          id={id}
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <span className="radio-tile">
          {mode === "breakdown" && (
            <span className="radio-icon">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                {" "}
                <rect width="256" height="256" fill="none"></rect>{" "}
                <polygon
                  points="72 40 184 40 240 104 128 224 16 104 72 40"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></polygon>{" "}
                <polygon
                  points="177.091 104 128 224 78.909 104 128 40 177.091 104"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></polygon>{" "}
                <line
                  x1="16"
                  y1="104"
                  x2="240"
                  y2="104"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></line>{" "}
              </svg>{" "}
            </span>
          )}
          {mode === "single" && (
            <span className="radio-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none"></rect>
                <circle
                  cx="128"
                  cy="64"
                  r="48"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></circle>
                <path
                  d="M32,216a96,96,0,0,1,192,0"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>
              </svg>
            </span>
          )}
          {mode === "team" && (
            <span className="radio-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none"></rect>
                {/* Left User */}
                <circle
                  cx="80"
                  cy="80"
                  r="40"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></circle>
                <path
                  d="M24,200a72,72,0,0,1,112,0"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>
                {/* Right User */}
                <circle
                  cx="176"
                  cy="80"
                  r="40"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></circle>
                <path
                  d="M120,200a72,72,0,0,1,112,0"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>
              </svg>
            </span>
          )}
          {mode === "question" && (
            <span className="radio-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none"></rect>

                <circle
                  cx="128"
                  cy="128"
                  r="96"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="12"
                ></circle>

                <path
                  d="M96 96a32 32 0 0 1 64 0c0 24-32 28-32 48"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>

                <circle cx="128" cy="176" r="8" fill="currentColor"></circle>
              </svg>
            </span>
          )}
          {mode === "locked" && (
            <span className="radio-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none"></rect>

                <rect
                  x="48"
                  y="112"
                  width="160"
                  height="112"
                  rx="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="12"
                ></rect>

                <path
                  d="M80 112V80a48 48 0 0 1 96 0v32"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>

                <circle cx="128" cy="168" r="8" fill="currentColor"></circle>
                <line
                  x1="128"
                  y1="176"
                  x2="128"
                  y2="196"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="12"
                ></line>
              </svg>
            </span>
          )}
          {mode === "unlocked" && (
            <span className="radio-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="192"
                height="192"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <rect width="256" height="256" fill="none"></rect>

                <rect
                  x="48"
                  y="112"
                  width="160"
                  height="112"
                  rx="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="12"
                ></rect>

                <path
                  d="M160 112V80a48 48 0 0 0-96 0"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="12"
                ></path>

                <circle cx="128" cy="168" r="8" fill="currentColor"></circle>
                <line
                  x1="128"
                  y1="176"
                  x2="128"
                  y2="196"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="12"
                ></line>
              </svg>
            </span>
          )}
          <span className="radio-label">{title}</span>
        </span>
      </label>
    </div>
  );
};

export default RadionButton2;
